const EXPORT_FILE_METHODS = {
    DEFAULT: 'queueExportFile',

    directExportFile: 'directExportFile',
    queueExportFile: 'queueExportFile',
};

export { EXPORT_FILE_METHODS };
